<template>
  <section class="input-email default">
    <input
        ref="input"
        :type="type"
        :id="name"
        :name="name"
        :value="value"
        :placeholder="placeholder"
        :minlength="minlength"
        :maxlength="maxlength"
        :pattern="pattern"
        :disabled="disabled"
        :required="required"
        :inputmode="inputmode"
        @[(lazy?`change`:`input`)]="$emit('update:value', $event.target.value)"
    />
    <slot name="icon"/>
  </section>
</template>

<script>
import inputMixin from '../../_shared/inputMixin';
import Icon from '../../../icon/Icon.vue';

export default {
  name: 'inputEmailDefault',
  mixins: [inputMixin],
  components:{Icon},
  props: {
    type: String,
    inputmode: String,
    minlength: Number,
    maxlength: Number,
    lazy: {
      type: Boolean,
    },
    pattern: String,
  },
};
</script>
